class TurnoverController extends AbstractController
	@register()
	@inject 'translate',
		'HighChartsThemeProviderService'
		'MessageTerminal'
		'MessageTypes'
		'ReportService'
		'ConfigurationService'
		'UserInformation'
		'CurrencyRepository'
		'UserShopRepository'
		'DateService'
		'BACKEND_ORDERS_ANALYTICS_QUERY_TYPE'
		'SECONDS'

	initialize: ->
		@isVatRateEnabled = @ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'
		@defaultCurrency = @UserInformation.getMasterUser().currency
		@categories = []

		@filters = {
			start_time: moment().startOf('month').unix()
			end_time: moment().endOf('month').unix()
			currency: @defaultCurrency
			shop_id: null
			is_vat_included: @isVatRateEnabled
		}

		@resolveGroupingOptions()

		@createChart()
		@MessageTerminal.on(@$scope,@MessageTypes.CSS_LOADED, @resizeChart.bind(@))

	toggleVat: ->
		@filters.is_vat_included = !@filters.is_vat_included
		@search()

	createChart: ->
		Highcharts.setOptions @HighChartsThemeProviderService.get('areaTheme', 'dynamic')
		Highcharts.setOptions
			global:
				useUTC: false

		chartInit = =>
			chartIndex = $('#turnover-graph').highcharts({
				title: {text: @translate('wbo.turnover.graph.title')}
				series: [
					{
						name: @translate('wbo.turnover.graph.current.period')
						data: []
						fillOpacity: 0.75
					}
					{
						name: @translate('wbo.turnover.graph.last.period')
						data: false
						fillOpacity: 0.2
						visible: false
						events: {
							legendItemClick: (event) =>
								if !event.target.data.length && event.target.visible == false
									@isGraphLoading = true

									range = @filters.end_time - @filters.start_time

									@ReportService
										.getOrdersAnalytics(
											@filters.start_time - range,
											@filters.end_time - range,
											@filters.currency,
											@filters.is_vat_included,
											true,
											@groupIntervalSize,
											@filters.shop_id,
											[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROUPED_TURNOVER]
										)
										.then (results) =>
											@isGraphLoading = false

											intervals = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROUPED_TURNOVER]
											data = @getSeriesData(intervals, @filters.start_time - range, @groupIntervalSize, @tickFormat)

											@chart.series[1].setData(Object.values(data))
						}
					}
				]
				legend: {
					layout: 'horizontal'
					backgroundColor: '#FFFFFF'
					align: 'left'
					verticalAlign: 'top'
					floating: false
					symbolRadius: 12
					symbolWidth: 12
					symbolPadding: 8
					x: 90
					y: 45
					enabled: true
				}
			}).data('highchartsChart')

			@chart = Highcharts.charts[chartIndex]

		watcher = setInterval((->
			if $('#turnover-graph').width() > 10
				clearInterval watcher
				chartInit()
			return
		), 100)

		@search()

	resetLastPeriodChart: ->
		return unless @chart?
		@chart.series[1].setData([])
		@chart.series[1].setVisible(false)

	resizeChart: ->
		@chart.reflow() if @chart

	searchCurrencies: (query) ->
		return @CurrencyRepository
			.findByQuery(query)
			.then (response) -> response.data
			.then (currencies) -> _.map(
				currencies,
				(currency) -> {
					currency...
					currency_name: "#{currency.currency_name} (#{currency.iso})"
				},
			)

	searchShops: (query) ->
		query.with('price_region')

		return @UserShopRepository
			.findByQuery(query)
			.then (response) -> response.data

	onShopChange: (shop) ->
		@filters.currency = shop?.price_region?.currency ? @defaultCurrency
		@search()

	onCurrencyChange: ->
		@search()

	onDateRangeChange: ->
		@resolveGroupingOptions()
		@search()

	resolveGroupingOptions: ->
		range = @filters.end_time - @filters.start_time

		@groupIntervalSize = @SECONDS.DAY
		@tickFormat = 'MMM YYYY'

		if range < 31 * @SECONDS.DAY
			@tickFormat = 'D. MMM'

		if range < @SECONDS.DAY
			@groupIntervalSize = @SECONDS.HOUR
			@tickFormat = 'HH:mm'

	search: ->
		@isGraphLoading = true

		reports = [
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROUPED_TURNOVER,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TURNOVER,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_PRODUCTS,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_USERS,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_REGISTERS,
			@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_SHOPS,
		]

		@ReportService
			.getOrdersAnalytics(
				@filters.start_time,
				@filters.end_time,
				@filters.currency,
				@filters.is_vat_included,
				true,
				@groupIntervalSize,
				@filters.shop_id,
				reports
			)
			.then (results) =>
				@isGraphLoading = false

				@topProducts = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_PRODUCTS]
				@topUsers = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_USERS]
				@topRegisters = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_REGISTERS]
				@topShops = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TOP_SHOPS]
				@turnoverPeriod = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.TURNOVER]

				intervals = results[@BACKEND_ORDERS_ANALYTICS_QUERY_TYPE.GROUPED_TURNOVER]

				data = @getSeriesData(intervals, @filters.start_time, @groupIntervalSize, @tickFormat)

				@chart.axes[0].update({categories: Object.keys(data)})
				@chart.series[0].setData(Object.values(data))
				@resetLastPeriodChart()

	getSeriesData: (intervals, startTime, groupIntervalSize, tickFormat) ->
		data = {}

		for index in [0...intervals.length]
			interval = intervals[index]
			timestamp = parseInt(startTime + parseInt(index * groupIntervalSize)) * 1000
			tick = moment(timestamp).format(tickFormat)
			data[tick] ?= 0
			data[tick] += parseFloat(interval.amount / 100)

		return data
